import { ChangeCell } from "@similarweb/pro-logic-components";

import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { changeFilter } from "app/filters/ngFilters";

const formatChange = changeFilter();

/** Keeps MoM/period change arrows in sync with the Rank Change column's `ChangeCell` icon. */
export const PercentageChangeCell = ({ value, row }: ITableCellProps<number | undefined, { precision?: number }>) => (
    <ChangeCell
        value={value}
        formattedValue={formatChange(Math.abs(value ?? 0), row?.precision)}
        noChangeSign="-"
    />
);

PercentageChangeCell.displayName = "PercentageChangeCell";
